import { useTranslation } from 'react-i18next'
import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import { ModalMessage, compactModalOverrides } from './styled-components'

interface Props {
  isOpen: boolean
  onClose: () => void
}

const DeleteAddressBlockedModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation()

  return (
    <SDModal
      isOpen={isOpen}
      openHandler={onClose}
      title={t('subscriptionForm:address_module.delete_address.blocked_title')}
      overrides={compactModalOverrides}
      sections={
        <ModalMessage>{t('subscriptionForm:address_module.delete_address.blocked_message')}</ModalMessage>
      }
    />
  )
}

export default DeleteAddressBlockedModal
